import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IOutdatedAlertInfo } from "@comunicare/comunicare-interfaces";

@Component({
  selector: "app--observation-simplified-alerts-history-modal",
  templateUrl: "./observation-simplified-alerts-history-modal.component.html",
  styleUrls: ["./observation-simplified-alerts-history-modal.component.scss"],
})
export class ObservationSimplifiedAlertsHistoryModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      outdatedAlerts: IOutdatedAlertInfo[];
    }
  ) {}
}
